import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, Validators} from "@angular/forms";


@Component({
  selector: 'home365-add-link-component',
  templateUrl: './add-link-component.component.html',
  styleUrls: ['./add-link-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class AddLinkComponentComponent {

  private reg = '(https?:\\/\\/)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)';
  linkText = new FormControl;
  link= new FormControl(null, [Validators.required, Validators.pattern(this.reg)]);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AddLinkComponentComponent>) {
    if (this.data.isCloseAuto) {
      setTimeout(() => {
        this.dialogRef.close();
      }, 2000);
    }
  }

  close(button: any): void {
    if (button) {
      if (this.link.valid) {
        this.dialogRef.close({ eventClick: true, close: false, text: this.linkText.value, link: this.link.value});
      }
    } else {
      this.dialogRef.close({close: true});
    }
  }
}
